import React from "react";
import styled from "styled-components";
import HowTo from "../../../components/HowTo";
import Button from "../../../components/Button";

const HireUI = styled.section`
  display: flex;
  padding: 70px 40px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--white);
  color: var(--black);
  gap: 30px;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  font-family: var(--raleway);
  color: var(--black);
  text-align: center;
  span {
    color: var(--red);
  }
  @media (max-width: 400px) {
    font-size: 2.2rem;
  }
`;

const Paragraph = styled.p`
  color: var(--black);
  font-size: 1.1rem;
  font-weight: 400;
  text-align: justify;
  line-height: 1.6rem;
  font-family: var(--roboto);
  text-align: center;
`;

const HireUs = ({ page }) => {
  return (
    <>
      <HireUI>
        <Title>
          COMO <span>CONTRATARNOS</span>
        </Title>
        <Paragraph>
          Contratarnos es fácil y rapido, solo tenes que seguir los siguientes
          pasos:
        </Paragraph>
        <HowTo />
        {!page && (
          <Button text="Ver más" path="/como-contratarnos" inverted></Button>
        )}
      </HireUI>
    </>
  );
};

export default HireUs;
